import { State } from 'modules/data';
import { TypedUseSelectorHook, useSelector as useUnknownSelector } from 'react-redux';
/**
 * Below is a typed version if Redux's `useSelector` with predefined `State` type
 * so that you don't have to manually set the type of the state parameter every time.
 */
export const useSelector: TypedUseSelectorHook<State> = useUnknownSelector;
